module.exports = __webpack_public_path__ + "static/img/Consulting05.16249a63.png";